import './textField.css';

interface TextProps {
    children: React.ReactNode;
    size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
    color?: 'green' | 'red' | 'black' | 'white' | 'subtitle' | 'subtitle-alt';
    weight?: 'regular' | 'bold' | 'semi';
    customisation?: string;
}

const TextField: React.FC<TextProps> = ({
    children,
    size = 'm',
    color = 'black',
    weight = 'regular',
    customisation = '',
}) => {
    return (
        <p className={`text-field ${color} ${size} ${weight} ${customisation}`}>
            {children}
        </p>
    );
};

export default TextField;
